import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'

import styles from './status-icon.module.css'

StatusIcon.propTypes = {
    children: PropTypes.element.isRequired,
    className: PropTypes.string,
    statusComponent: PropTypes.element
}

StatusIcon.defaultProps = {
    className: '',
    statusComponent: null
}

/**
 * @constructor
 *
 * This <code>StatusIcon</code> can be used within the {@link ViewHeader} as the child.
 * @see {@link https://tttconfluence.ttg.global:8443/display/TTB/Molecules#Molecules-ViewHeader}
 *
 * @param {ReactElement} statusComponent   - a React component placed to the bottom right corner.
 * @param {ReactElement} children          - a React icon component (SVG).
 * @param {string} [className]             - a custom CSS class name for the outer DIV element.
 *
 * @example
 *     <StatusIcon statusComponent={<StatusIndicator color='green' />}>
 *         <ParkingIcon />
 *     </StatusIcon>
 */
function StatusIcon({ children, className, statusComponent }) {
    const icon = React.Children.only(children)
    return (
        <span className={cx(styles['main'], className)}>
            <span className={styles['icon']}>{icon}</span>
            {statusComponent && <div className={styles['status']}>{statusComponent}</div>}
        </span>
    )
}

export default StatusIcon
